<template>
  <div>
    <a-row :gutter="24" type="flex">
      <a-col :span="24" class="mb-24">
        <key-table
          ref="KeyTable"
          @addClick="AddClick"
          @editClick="EditClick"
          @buildClick="BuildClick"
        />
      </a-col>
    </a-row>

    <a-modal
      v-model:open="EditModelVisible"
      :title="amodelTitle"
      :width="amodelWidth"
      :wrap-class-name="amodelHeight"
    >
      <template #footer></template>
      <!-- <cate-edit
        :cateMod="selCateMod"
        @EditKeyComHandle="EditKeyCom"
        @CancleEdit="CancleEdit"
      /> -->
      <key-edit
        :keyMod="selKeywordMod"
        @EditComHandle="EditComHandle"
      ></key-edit>
    </a-modal>

    <a-modal
      v-model:open="RelModelVisible"
      title="关键词关联设置"
      :width="amodelWidth"
      :wrap-class-name="amodelHeight"
    >
      <template #footer></template>
      <rel-build
        ref="relBuildRef"
        :keyMod="selKeywordMod"
        @BuildComHandle="RelBuildCom"
      ></rel-build>
    </a-modal>
  </div>
</template>

<script>
import { KeyTable, KeyEdit, RelBuild } from "./components/index";
import { getKeywordById } from "@/api/keyword";
export default {
  components: {
    KeyTable,
    KeyEdit,
    RelBuild,
  },
  data() {
    return {
      RelModelVisible: false,
      EditModelVisible: false,
      amodelTitle: "分类编辑",
      isMobile: false,
      selKeywordMod: {
        id: "",
        keyword: "",
        state: true,
      },
    };
  },
  created() {
    this.checkIfMobile();
  },
  computed: {
    amodelHeight() {
      return this.isMobile ? "full-modal" : "helf-modal";
    },
    amodelWidth() {
      return this.isMobile ? "100%" : "50%";
    },
  },
  methods: {
    AddClick() {
      this.amodelTitle = "关键字添加";
      this.selKeywordMod = {
        id: "",
        keyword: "",
        state: true,
      };
      this.EditModelVisible = true;
    },
    EditClick(keyMod) {
      this.amodelTitle = keyMod.id == "" ? "关键字添加" : "关键字编辑";
      this.selKeywordMod = Object.assign(keyMod);
      console.log(this.selKeywordMod);
      this.EditModelVisible = true;
    },
    EditComHandle(id) {
      this.EditModelVisible = false;
      if (id != "") {
        this.$confirm(
          "现在添加关键词关联，未添加关键词关联将不能抓取信息?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "稍后",
            type: "warning",
          }
        )
          .then(() => {
            getKeywordById(id).then((res) => {
              if (res.code == 0) {
                this.BuildClick(res.data);
              } else {
                this.$message.error(res.msg);
              }
            });
          })
          .catch(() => {
            this.selKeywordMod = {
              id: "",
              keyword: "",
              state: true,
            };
          });
      }
      this.selKeywordMod = {
        id: "",
        keyword: "",
        state: true,
      };
    },
    BuildClick(keyMod) {
      this.selKeywordMod = Object.assign(keyMod);
      this.RelModelVisible = true;

      this.$nextTick(() => {
        console.log(this.$refs); // 现在应该能看到 relBuildRef 了
        if (this.$refs["relBuildRef"]) {
          this.$refs["relBuildRef"].clearTreeSelection();
        }
      });
    },
    RelBuildCom() {
      this.RelModelVisible = false;
      this.$refs["KeyTable"].GetTableData();
    },
    checkIfMobile() {
      // 通常以768px作为移动设备的断点
      this.isMobile = window.innerWidth <= 768;
    },
  },
};
</script>

<style lang="scss">
</style>